import React, { useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { setGlobalStorage, getGlobalStorage, getMultiLang } from '@platform/api';
import { Button as NCButton } from '@platform/base';
import { default as PubSub } from 'pubsub-js';
import './index.less';
import './black.less';
const ICONS = {
    info: 'icon-shuoming2',
    warning: 'icon-zhuyi1'
};
const THUMBS = {
    info: require('./images/designEmpty.png'),
    warning: require('./images/warning.png')
};
// 重新显示
const resetNoHintFun = (hintId) => {
    setGlobalStorage('localStorage', `retain_hintnohint` + hintId, '');
    PubSub.publish('noHint', '')
}

export const SimpleHint = forwardRef((props, ref) => {
    // 点击不再提示按钮后，再也不出现
    let hintLocalVal = getGlobalStorage('localStorage', `retain_hintnohint` + props.hintId)
    const [show, setShow] = useState(hintLocalVal === '1' ? false : true);
    const [json, setJson] = useState({})
    const [footer,setFooter] = useState(false)
    useEffect(() => {
        PubSub.subscribe("noHint", (_, res) => {
            setShow(true)
        })
    }, [show])

    useEffect(() => {
        getMultiLang({ moduleId: 'container_simpleHint', callback });
    })

    useImperativeHandle(ref, () => ({
        controlHint: controlHint
    }))

  const callback = (json) => {
    const { hasFooter}=props
      setTimeout(() => {
        hasFooter&&setFooter(true)
      }, 0);
        setJson(json)
    };

    const controlHint = (show) => {
        setShow(show)
    }

    const footerBtns = [
        {
            btncolor: 'button_main',
            fieldid: 'close',
            title: json['0001'],//'我知道了',
            type: 'link',
            onClick: closeSimpleHint
        },
        {
            btncolor: 'button_Secondary',
            fieldid: 'nohint',
            title: json['0002'],//'不再提示',
            type: 'link',
            onClick: handleNoHint
        }
    ];

    function getHintClassName() {
        const { type } = props;
        const hintClassName = ['simplehint', `simplehint-${type}`, checkThumbType(), props.className];

        return hintClassName.join(' ');
    }

    function checkThumbType() {
        const { useThumb } = props;
        return useThumb ? 'use-thumb' : '';
    }

    function closeSimpleHint() {
        let { onClose } = props
        //  设置提示框不可见
        setShow(false);
        onClose && onClose()
    }

    function handleNoHint() {
        let { onNoHint } = props
        // 设置不再显示提示
        setGlobalStorage('localStorage', `retain_hintnohint` + props.hintId, '1');
        setShow(false)
        onNoHint && onNoHint()
    }

    function renderThumb() {
        let { type, icon = '', useThumb, thumb } = props;
        let thumbEl = null;
        if (typeof icon === 'string') {
            icon = icon || ICONS[type];
            thumbEl = <i className={`iconfont ${icon}`} />;
        } else {
            thumbEl = icon;
        }
        if (useThumb) {
            thumbEl = <img src={thumb || THUMBS[type]} />;
        }
        return (
            <div className="simplehint-thumb">
                {thumbEl}
            </div>
        );
    }

    function renderTitle() {
        let { useThumb, thumb, type } = props;
        return (
            <div className={`simplehint-title ${useThumb ? 'thumb-title' : (type === 'warning' ? 'icon-warning-title' : 'icon-info-title')}`}>{props.title}</div>
        );
    }

    function renderContent() {
        let { useThumb, thumb, type, hasMaxheight } = props;
        return (
            <div className={`${hasMaxheight ? 'simplehint-content' : 'simplehint-content-nomaxHeight'} ${useThumb ? 'thumb-content' : (type === 'warning' ? 'warning-content' : 'info-content')}`}>{props.overlay}</div>
        );
    }

    function renderFooter() {
        //带图标和带配图组件 都可配置底部按钮
        // const { hasFooter } = props;
        let buttons = footerBtns.map((btn) => (
            <NCButton key={btn.fieldid} {...btn}>{btn.title}</NCButton>
        ));
        return (
          footer && <div className="simplehint-footer">{buttons}</div>
        );
    }

    function renderCloseIcon() {
        const { hasCloseBtn } = props;
        return (
          hasCloseBtn&&<div className="simplehint-close">
                <i className="iconfont icon-guanbi" onClick={closeSimpleHint} />
            </div>
        );
    }

    return show && (
      <div className={getHintClassName()} ref={ref}
            fieldid={props.id}
            style={{ backgroundImage: 'url(' + props.bgImgUrl + ')', backgroundRepeat: 'no-repeat', backgroundSize: '100% 100%' }}>
            {renderThumb()}
            <div className="simplehint-inner" >
                {renderTitle()}
                {renderContent()}
                {renderCloseIcon()}
                {renderFooter()}
            </div>
        </div>
    );
})
SimpleHint.propTypes = {
    // 提示框类型（预警提示warning|帮助提示info）
    type: PropTypes.string,
    // 是否显示关闭按钮
    hasCloseBtn: PropTypes.bool,
    // 提示框标题
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    // 提示框内容
    overlay: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    // 提示框自定义图标
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    // 是否使用缩略图
    useThumb: PropTypes.bool,
    // 提示框自定义缩略图，缩略图地址
    thumb: PropTypes.string,
    // 提示框自定义按钮配置 [{label: '自定义按钮名称', onClick: (meta) => {}}]
    buttons: PropTypes.array,
    hasFooter: PropTypes.bool,
    bgImgUrl: PropTypes.string,
    hasMaxheight: PropTypes.bool
};

SimpleHint.defaultProps = {
    type: 'info',
    hasCloseBtn: false,
    icon: '',
    useThumb: false,
    thumb: '',
    buttons: [],
    hasFooter: false,
    bgImgUrl: '',
    hasMaxheight: true
};
SimpleHint.resetNoHintFun = resetNoHintFun
